<script setup lang="ts">
import { ref, watch } from 'vue'
import { capitalize } from 'lodash'
import { VModal, VSection, VTextField, VTextArea, VButton } from '@/modules/shared/components'
import { useModal } from '@/modules/shared/composables/use-modal'

const props = defineProps<{
  modalStore: ReturnType<typeof useModal>
  template: { id: number; name: string; message: string } | null
  onSave: (data: { name: string; email_message: string }) => Promise<void>
}>()

const formData = ref({
  name: '',
  email_message: '',
})

const loading = ref(false)

watch(
  () => props.template,
  (template) => {
    if (template) {
      formData.value.name = template.name || ''
      formData.value.email_message = template.message || ''
    }
  },
  { immediate: true },
)

const handleSave = async () => {
  loading.value = true
  await props.onSave({ ...formData.value })
  loading.value = false
}
</script>

<template>
  <VModal :modalStore="modalStore">
    <template #main>
      <VSection label="Edit Template Details">
        <form @submit.prevent="handleSave" class="space-y-6">
          <VTextField v-model="formData.name" :label="capitalize('template name')" property="name" type="text" />
          <VTextArea v-model="formData.email_message" :label="capitalize('email message')" property="email_message" />
        </form>
      </VSection>
    </template>
    <template #footer>
      <VButton :click="handleSave" class="w-full" size="lg" :loading="loading" variant="primary">
        Save Changes
      </VButton>
    </template>
  </VModal>
</template>
